export const DEFAULT_FORMATTING_OPTIONS = {
  decimalSeparator: '.',
  fractionDigits: 2,
  fixed: true,
  zeroes: false,
  positiveSymbol: '+',
  showPositiveSymbol: false
}

export function toFixed (number, fractionDigits) {
  const reg = new RegExp(`^-?\\d+(?:\\.\\d{0,${fractionDigits}})?`)
  const [fixedFloatNumber] = number.toString().match(reg)
  const dotIndex = fixedFloatNumber.indexOf('.')

  // For integers
  if (dotIndex === -1) {
    // Inserting decimal dot and padding up with zeroes
    return fixedFloatNumber + '.' + '0'.repeat(fractionDigits)
  }

  // Checking for the length of a fixed number
  // Determine if there are enough digits
  const missingZeros = fractionDigits - (fixedFloatNumber.length - dotIndex) + 1

  if (missingZeros > 0) {
    // Add the required number of zeros
    return (fixedFloatNumber + '0'.repeat(missingZeros))
  }

  return fixedFloatNumber
}

export function format (number, options = {}) {
  const formatOptions = {
    ...DEFAULT_FORMATTING_OPTIONS,
    ...options
  }

  let formattedValue

  // For fixed option - remove all numbers after fractionDigits
  if (formatOptions.fixed) {
    formattedValue = toFixed(number, formatOptions.fractionDigits)

    // If zeroes disabled
    if (!formatOptions.zeroes) {
      formattedValue = Number.parseFloat(formattedValue)
    }
  } else {
    formattedValue = number
  }

  if (formatOptions.showPositiveSymbol && (number > 0)) {
    formattedValue = (formatOptions.positiveSymbol + formattedValue)
  }

  return formattedValue + ''
}

export function oddsToPercentage (odds) {
  const percentage = format(
    odds * 100 - 100,
    {
      fractionDigits: 2,
      fixed: true,
      zeroes: false
    }
  )

  return `${percentage}%`
}
